const loginTranslations =
  {
    en: {
      loginTitle: 'Login',
      loginButton: 'Login',
      signIn: 'Sign in to your account',
      passwordPlaceholder: 'Password',
      usernamePlaceholder: 'Username',
      forgotPassword: 'Forgot password?',
      description: "Welcome to the Risk Reporting Tool<br><br>" +
        "This tool is intended to assist you in the declaration of risks by the collection and the validation of the quality of the data.<br><br>" +
        "For any request for additional information, please contact: "
    },
    fr: {
      loginTitle: 'Identification de l\'utilisateur',
      loginButton: 'Connexion',
      signIn: 'Connectez-vous à votre compte',
      passwordPlaceholder: 'Mot de passe',
      usernamePlaceholder: 'Nom d\'utilisateur',
      forgotPassword: 'Vous avez oublié votre mot de passe ?',
      description: "Bienvenue sur l’outil de déclaration de risques​<br><br>" +
        "Cet outil a pour but de vous assister dans la déclaration de risques par adhérent et la validation de la qualité de données.​<br><br>" +
        "Pour toute demande d'information supplémentaire, contactez: "
    },
  };
export default loginTranslations;
